import { formatInteger } from '@monetize/utils/core';
import {
  MButton,
  MFlex,
  MStack as Stack,
  MText,
} from '../../../../components/Monetize';
import { pluralize } from '../../../../utils';

interface MassVoidModalFooterProps {
  total: number;
  success?: number;
  failure?: number;
  isLoading: boolean;
  hasSubmitted: boolean;
  isSubmitDisabled: boolean;
  onCancel: () => void;
}

export const MassVoidModalFooter = ({
  total,
  success,
  failure,
  isLoading,
  hasSubmitted,
  isSubmitDisabled,
  onCancel,
}: MassVoidModalFooterProps) => {
  const hasResult = success !== undefined || failure !== undefined;
  return (
    <MFlex w="100%" justifyContent="space-between" alignItems="center">
      <Stack gap={1} direction="column">
        {hasResult && (
          <>
            {!!success && (
              <MText color="tGreen.approval">
                {formatInteger(success)} {pluralize('invoice', success)} voided
              </MText>
            )}
            {!!failure && (
              <MText color="tRed.base">
                {formatInteger(failure)} {pluralize('error', failure)}
              </MText>
            )}
          </>
        )}
      </Stack>
      <Stack gap={4} direction="row" align="center" justify="right" flex={1}>
        <MButton
          variant="cancel"
          minW="auto"
          onClick={onCancel}
          isDisabled={isLoading}
        >
          {hasSubmitted ? 'Close' : 'Cancel'}
        </MButton>
        {!hasSubmitted && (
          <MButton
            variant="primary"
            minW="auto"
            type="submit"
            form="mass-void-form"
            isDisabled={isLoading || isSubmitDisabled}
            isLoading={isLoading}
          >
            Void {formatInteger(total)} {pluralize('Invoice', total)}
          </MButton>
        )}
      </Stack>
    </MFlex>
  );
};
